import {Collapse, styled} from '@mui/material';

export const ECollapse = styled(Collapse)``;
